import { render, staticRenderFns } from "./main-section-tertiary.vue?vue&type=template&id=1be00a0e&scoped=true"
import script from "./main-section-tertiary.vue?vue&type=script&lang=js"
export * from "./main-section-tertiary.vue?vue&type=script&lang=js"
import style0 from "./main-section-tertiary.vue?vue&type=style&index=0&id=1be00a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be00a0e",
  null
  
)

export default component.exports